import { SUPABASE_URL, SUPABASE_ANON_KEY } from '../config/env';

const supabaseRequest = async (endpoint, options = {}) => {
  const response = await fetch(`${SUPABASE_URL}${endpoint}`, {
    ...options,
    headers: {
      'apikey': SUPABASE_ANON_KEY,
      'Authorization': `Bearer ${SUPABASE_ANON_KEY}`,
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
  if (!response.ok) {
    const error = await response.json().catch(() => ({ message: 'Request failed' }));
    throw new Error(error.message || 'Request failed');
  }
  return response.json();
};

export class CourierManagerService {
  static async getShipments() {
    try {
      const data = await supabaseRequest(`/rest/v1/rpc/courier_manager_get_shipments`, {
        method: 'POST',
        body: JSON.stringify({}),
      });
      return { success: true, data: data || [], error: null };
    } catch (error) {
      console.error('Error fetching shipments:', error);
      return { success: false, data: [], error: error.message };
    }
  }

  static async getOrders() {
    try {
      const data = await supabaseRequest(`/rest/v1/rpc/courier_manager_get_orders`, {
        method: 'POST',
        body: JSON.stringify({}),
      });
      return { success: true, data: data || [], error: null };
    } catch (error) {
      console.error('Error fetching orders:', error);
      return { success: false, data: [], error: error.message };
    }
  }

  static async updateShipmentStatus(shipmentId, status) {
    try {
      const data = await supabaseRequest(`/rest/v1/rpc/courier_manager_update_shipment_status`, {
        method: 'POST',
        body: JSON.stringify({ p_shipment_id: shipmentId, p_status: status }),
      });
      return { success: true, data, error: null };
    } catch (error) {
      console.error('Error updating shipment status:', error);
      return { success: false, error: error.message };
    }
  }
}

